<template>
  <div class="page-view logout">
    <div class="msg">
      Confirm logout of user information ?
    </div>
    <div class="btns fx fx-center">
      <van-button class="btn" plain round type="info" size="small" @click="cancel">
        Cancel
      </van-button>
      <van-button class="btn" round type="info" size="small" @click="confirm">
        Confirm
      </van-button>
    </div>
  </div>
</template>

<script>
import { Dialog } from 'vant'
export default {
  data () {
    return {

    }
  },
  created () {

  },
  methods: {
    // 注销
    delAccount (params) {
      return this.$http.post('/olvp/delAccount', 'delAccount', params, false, false)
    },
    cancel () {
      this.$router.replace('/home')
    },
    confirm () {
      let that = this
      Dialog.confirm({
        title: 'Confirm',
        message: 'Your account information will be deleted soon'
      })
        .then(() => {
          // on confirm
          that.del()
        })
        .catch(() => {
          // on cancel
        })
    },
    del () {
      this.delAccount({
        phoneBindingAccount: this.$util.storageGet('local', 'phone'),
        facebookBindingAccount: this.$util.storageGet('local', 'facebookId') || '',
        token: this.$util.storageGet('local', 'token')
      }).then((res) => {
        if (res.success) {
          this.$util.storageDel('local', 'token')
          this.$util.storageDel('local', 'phone')
          this.$util.storageDel('local', 'platform')
          this.$util.storageDel('local', 'name')
          this.$util.storageDel('local', 'picture')
          this.$util.storageDel('local', 'facebookId')
          this.$util.storageDel('local', 'memberId')
          this.$facebook.checkFB().then(() => { // FB对象初始化
            /* eslint-disable no-undef */
            FB.logout(function (response) {
              // user is now logged out
            })
          })
          this.$cux.toast({
            message: 'Your account has been cancelled',
            type: 'success'
          })
        }
      })
    }
  }
}
</script>

<style lang="scss">
  .logout {
    width: 100%;
    padding: 30px;
    position: relative;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .msg {
      text-align: center;
      margin-bottom: 25vh;
      font-size: 30px;
      font-weight: bold;
    }
    .btns .btn:nth-child(1) {
      width: 30vw;
      margin-right: 10px;
    }
    .btns .btn:nth-child(2) {
      width: 30vw;
      margin-left: 10px;
    }
  }
</style>
